import { render, staticRenderFns } from "./ParamsDialog.vue?vue&type=template&id=6ebe657e&"
import script from "./ParamsDialog.vue?vue&type=script&lang=ts&"
export * from "./ParamsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ParamsDialog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports